<template lang="html">
  <div class="col-12 profile-favorites-box no-pad-both">
    <div id="favorites-empty-data" class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 white-box" v-if="noFavoriteData">
      <div><span class="material-icons" aria-hidden="true">favorite</span></div>
      <h4>Du har endnu ikke tilføjet favoritter</h4>
      <p>
        Her finder du de steder, du har tilføjet som favoritter.
        Du kan tilføje steder og temaer som favoritter ved at klikke på hjerterne på forslagssiden, menusiden, temasiderne og stedsiderne.
        Så har du dem altid lige ved hånden.
      </p>
    </div>
    <div id="profile-favorites" class="white-box" v-else>

      <ul id="profile-favorites-list" class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 text-center">
        <li class="col-4 grey-text" aria-label="Vis favorit links" :class="{active : activeTab == 'links'}" @click="activeTab = 'links'" tabindex="0">Links</li>
        <li class="col-4 grey-text" aria-label="Vis favorit steder" :class="{active : activeTab == 'places'}" @click="activeTab = 'places'" tabindex="0">Steder</li>
        <li class="col-4 grey-text" aria-label="Vis favorit temaer" :class="{active : activeTab == 'tags'}" @click="activeTab = 'tags'" tabindex="0">Temaer</li>
      </ul>

      <ul id="profile-favorites-list-link" class="col-12 no-pad-both" aria-label="Liste over favorit links" v-show="activeTab == 'links'">
        <template v-for="(feature) in favoriteData.link" >
          <ProfileFavoriteChild :childData="feature" @dataChanged="getFavoriteData"></ProfileFavoriteChild>
        </template>
      </ul>
      <ul id="profile-favorites-list-place" class="col-12 no-pad-both" aria-label="Liste over favorit steder" v-show="activeTab == 'places'">
        <template v-for="(feature) in favoriteData.place">
          <ProfileFavoriteChild :childData="feature" @dataChanged="getFavoriteData"></ProfileFavoriteChild>
        </template>
      </ul>
      <ul id="profile-favorites-list-tag" class="col-12 no-pad-both" aria-label="Liste over favorit temaer" v-show="activeTab == 'tags'">
        <template v-for="(feature) in favoriteData.themes">
          <ProfileFavoriteChild :childData="feature" @dataChanged="getFavoriteData"></ProfileFavoriteChild>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import ProfileFavoriteChild from '@/components/profile/ProfileFavoriteChild.vue'

export default {
  data() {
    return {
      favoriteData: {
        'address': [],
        'link': [],
        'place': [],
        'themes': [],
      },
      activeTab: 'places',
      noFavoriteData: false,
    }
  },
  components: {
    ProfileFavoriteChild,
  },
  created() {
    this.getFavoriteData();
  },
  methods: {
    getFavoriteData() {
      Profile.getUserData().then((data) => {
        Profile.getLikeData(data.likes).then((finalData) => {
          console.log(finalData);
          if(finalData.link.length == 0 && finalData.place.length == 0 && finalData.themes.length == 0) {
            this.noFavoriteData = true;
          }
          else {
            this.favoriteData = finalData;
          }
        });
      });
    },
  }
}
</script>

<style lang="css" scoped>
  #profile-favorites-list {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #profile-favorites-list li {
  	cursor: pointer;
    display: inline-block;
  	text-align: center;
    line-height: 48px;
    height: 48px;
    padding: 0;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: .8px;
  }

  #profile-favorites-list li.active {
  	border-bottom: 3px solid rgb(000,112,141);
  	color: rgb(000,112,141);
  }

  #favorites-empty-data {
    margin-top: 10px;
    padding: 10px 5px;
    height: auto;
    text-align: center;
  }
</style>
